import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const FormTitle = styled.span.attrs({ className: 'hl3' })``;

export const FormInput = styled.div`
  margin-top: 15px;
`;

export const FormCheckBoxes = styled.div`
  display: flex;
  margin-top: 15px;

  label {
    margin-left: 25px;
    &:first-child {
      margin-left: 0;
    }
  }
`;

export const FormSubTitle = styled.span.attrs({ className: 'body_text' })`
  color: ${({ theme }) => theme.baseBlue.a6};
`;
